import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
// import { DragulaModule } from "ng2-dragula";
import { TranslateModule } from "@ngx-translate/core";
import { Select2Module } from 'ng-select2-component';
// Components
import { BreadcrumbComponent } from "./components/breadcrumb/breadcrumb.component";
import { FeatherIconsComponent } from "./components/feather-icons/feather-icons.component";
import { FooterComponent } from "./components/footer/footer.component";
import { HeaderComponent } from "./components/header/header.component";
import { ContentComponent } from "./components/layout/content/content.component";
import { LoaderComponent } from "./components/loader/loader.component";
import { SidebarComponent } from "./components/sidebar/sidebar.component";
import { TapToTopComponent } from "./components/tap-to-top/tap-to-top.component";
// Header Elements Components
import { BookmarkComponent } from "./components/header/elements/bookmark/bookmark.component";
import { CartComponent } from "./components/header/elements/cart/cart.component";
import { LanguagesComponent } from "./components/header/elements/languages/languages.component";
import { MegaMenuComponent } from "./components/header/elements/mega-menu/mega-menu.component";
import { MessageBoxComponent } from "./components/header/elements/message-box/message-box.component";
import { MyAccountComponent } from "./components/header/elements/my-account/my-account.component";
import { NotificationComponent } from "./components/header/elements/notification/notification.component";
import { SearchComponent } from "./components/header/elements/search/search.component";
// Services
import { DecimalPipe } from "@angular/common";
import { SwiperModule } from "swiper/angular";
import { SwiperComponent } from './components/header/elements/swiper/swiper.component';
import { SvgIconComponent } from "./components/svg-icon/svg-icon.component";
import { LayoutService } from "./services/layout.service";
import { NavService } from "./services/nav.service";
import { CardComponent } from "../shared/common-component/card/card.component";
import { NgApexchartsModule } from "ng-apexcharts";
import { InputComponent } from "../shared/common-component/input/input.component";
import { SearchInputComponent } from "../shared/common-component/search-input/search-input.component";
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxDatatableComponent } from "./common-component/ngx-datatable/ngx-datatable.component";
import { EditDeleteIconComponent } from "./common-component/edit-delete-icon/edit-delete-icon.component";
import { ButtonComponent } from "./common-component/button/button.component";
import { CheckboxComponent } from "./common-component/checkbox/checkbox.component";
import { SelectComponent } from "./common-component/select/select.component";
import { SearchableDropdownComponent } from "./common-component/searchable-dropdown/searchable-dropdown.component";
@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    ContentComponent,
    BreadcrumbComponent,
    FeatherIconsComponent,
    LoaderComponent,
    TapToTopComponent,
    SearchComponent,
    MegaMenuComponent,
    LanguagesComponent,
    NotificationComponent,
    BookmarkComponent,
    CartComponent,
    MessageBoxComponent,
    MyAccountComponent,
    SvgIconComponent,
    SwiperComponent,
    CardComponent,
    InputComponent,
    SearchInputComponent,
    NgxDatatableComponent,
    EditDeleteIconComponent,
    ButtonComponent,
    CheckboxComponent,
    SelectComponent,
    SearchableDropdownComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    NgbModule, NgApexchartsModule,
    Select2Module,
    // DragulaModule.forRoot(),
    TranslateModule.forRoot(),
    SwiperModule],
  providers: [NavService, LayoutService, DecimalPipe],
  exports: [NgbModule, FormsModule, ReactiveFormsModule,
    TranslateModule, NgApexchartsModule, NgxDatatableModule, NgxDatatableComponent, EditDeleteIconComponent, ButtonComponent, CheckboxComponent, SelectComponent,
    LoaderComponent, BreadcrumbComponent, FeatherIconsComponent, TapToTopComponent, SvgIconComponent, SwiperModule, CardComponent, InputComponent,
    SearchInputComponent, SearchableDropdownComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule { }
